import React from 'react';
import cryptocurrencies from './paymentMethods.json';

const JsonData = React.createContext();

export { JsonData, cryptocurrencies };
